import { useState } from 'react'
import { message as $message } from 'antd'

import {
    NO_ORDER_KEY,
    OLD_HAS_NO_ORDER_30D_KEY,
    NEW_HAS_ORDER_30D_KEY,
    LOSS_7DAY_KEY,
    LOSS_KEY,
    POTENTIAL_7DAY_KEY,
    POTENTIAL_KEY,
    TO_BE_DEVELOPED_KEY,
    INCREASE_DISTR_SENT_AMT_7D_KEY
} from '@/modules/distribute/constants/distributionAccountQuickStatus'
import { queryPartnerStatsNum } from '@/services/myPartner'
import { queryNoCoopVisitorCount } from '@/services/distributionAccountCenter'

export default () => {
    const [countData, setCountData] = useState(null)

    const loadPartnerStatusCount = async () => {
        const { success, message, data } = await queryPartnerStatsNum({
            statsDimensions: [
                OLD_HAS_NO_ORDER_30D_KEY,
                NEW_HAS_ORDER_30D_KEY,
                'NEW_HAS_NO_ORDER_30D',
                'POTENTIAL_LOSS_30D',
                'POTENTIAL_RISE_30D',
                'POTENTIAL_LOSS_7D',
                'POTENTIAL_RISE_7D',
                INCREASE_DISTR_SENT_AMT_7D_KEY
            ]
        })

        if (success) {
            setCountData(pre => {
                return {
                    ...(pre || {}),
                    [OLD_HAS_NO_ORDER_30D_KEY]: data.noOrderOldNum,
                    [NO_ORDER_KEY]: data.noOrderNum,
                    [LOSS_7DAY_KEY]: data.lossNum7d,
                    [LOSS_KEY]: data.lossNum,
                    [POTENTIAL_7DAY_KEY]: data.potentialNum7d,
                    [POTENTIAL_KEY]: data.potentialNum,
                    [NEW_HAS_ORDER_30D_KEY]: data.newHasOrderNum,
                    [INCREASE_DISTR_SENT_AMT_7D_KEY]: data.increaseDistrSentAmt7d
                }
            })
        } else {
            $message.error(message)
        }
    }

    const loadQueryVisitorStatCount = async () => {
        const { success, message, data } = await queryNoCoopVisitorCount({
            lastVisitTimeEnum: 'NEARLY_THIRTY_DAYS'
        })

        if (success) {
            setCountData(pre => {
                return {
                    ...(pre || {}),
                    [TO_BE_DEVELOPED_KEY]: data?.notCoopVisitorCount
                }
            })
        } else {
            $message.error(message)
        }
    }

    return {
        countData,
        loadPartnerStatusCount,
        loadQueryVisitorStatCount
    }
}
